module.exports = __webpack_public_path__ + "why1.webp?d3931a89c080cd4c327d6129b9041e7d";